<script setup>
import Select from 'dashboard/components-next/select/Select.vue';

defineProps({
  modelValue: { type: String, default: '' },
  options: { type: Array, default: () => [] },
  placeholder: { type: String, default: '' },
  hasError: { type: Boolean, default: false },
});

defineEmits(['update:modelValue']);
</script>

<template>
  <div
    class="ms-auto w-full max-w-[15rem]"
    :class="{ 'animate-shake': hasError }"
  >
    <Select
      :model-value="modelValue || null"
      :options="options"
      :placeholder="placeholder"
      searchable
      @update:model-value="$emit('update:modelValue', $event || '')"
    />
  </div>
</template>
